export default __webpack_public_path__ + "aedd266423db7fe764e75b2fc1d6f6a2.svg";